import { SnackbarNotificationState } from '@slices/snackbar-notification';

import { SnackbarNotification } from '@types';

import { appCreateSelector, RootState } from '@store';

export const snackbarNotificationGet = (
  state: RootState
): SnackbarNotificationState => {
  return state.ui.snackbarNotification;
};

export const snackbarNotificationGetList: (
  state: RootState //
) => SnackbarNotification[] = appCreateSelector(
  [snackbarNotificationGet], //
  (snackbarNotification) => snackbarNotification.notifications
);
